/**
 * Show/hide Group Management features
 * Clean-up: ORB-1141
 */
const isGroupManagementEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GROUP_MANAGEMENT_ENABLED === "true";

/**
 * Show/hide Search Location feature
 * Clean-up: ORB-1149
 */
const isSearchLocationEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_SEARCH_LOCATION_ENABLED === "true";

/**
 * Show/hide Change Password feature
 * Clean-up: ORB-1150
 */
const isChangePasswordEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_CHANGE_PASSWORD_ENABLED === "true";

/**
 * Show/hide Template feature
 * Clean-up: ORB-1028, ORB-1029
 */
const isTemplateEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_TEMPLATE_ENABLED === "true";

/**
 * Show/hide Group List on Add New User panel
 * Clean-up: TBD
 */
const isGroupListOnAddNewUserEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GROUP_LIST_ON_ADD_NEW_USER_ENABLED ===
  "true";

/**
 * Show/hide Draw Polygon feature
 * Clean-up: ORB-1150, ORB-1065
 */
const isDrawPolygonEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_DRAW_POLYGON_ENABLED === "true";

/**
 * Use New Dataset Explorer Modal feature
 * Clean-up: ORB-1390, ORB-1392
 */
const isUseNewDatasetExplorerModal =
  import.meta.env.VITE_FEATURE_FLAG_IS_USE_NEW_DATASET_EXPLORER_MODAL ===
  "true";

/**
 * Show/hide Analysis Job List feature
 * Clean-up: ORB-1460
 */
const isAnalysisJobListEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ANALYSIS_JOB_LIST_ENABLED === "true";

/**
 * Show/hide Storage Limit feature
 * Clean-up: ORB-1460
 */
const isStorageLimitEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_STORAGE_LIMIT_ENABLED === "true";

/**
 * Show/hide Rename Dataset feature
 * Clean-up: TBD
 */
const isRenameDatasetEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_RENAME_DATASET_ENABLED === "true";

/**
 * Show/hide Edit User feature
 * Clean-up: ORB-625
 */
const isEditUserEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_EDIT_USER_ENABLED === "true";

/**
 * Show/hide POI Info feature
 * Clean-up: TBD
 */
const isPOIInfoEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_POI_INFO_ENABLED === "true";

/**
 * Enable login with SSO
 * Clean-up: TBD
 */
const isLoginWithSsoEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_LOGIN_WITH_SSO_ENABLED === "true";

/**
 * Enable Base Map Style Selector
 * Clean-up: ORB-1623
 */
const isBaseMapStyleSelectorEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_BASE_MAP_STYLE_SELECTOR_ENABLED ===
  "true";

/**
 * Updated UI dataset
 * Clean-up: TBD
 */

const isNewUIDatasetConfigEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_NEW_DATASET_CONFIG_ENABLED === "true";

const isRankingLabelEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_RANKING_LABEL_ENABLED === "true";

/*
 * Enable refactor Add Dataset flow
 * Clean-up: TBD
 */
const isRefactorAddDatasetEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_REFACTOR_ADD_DATASET === "true";

/*
 * Show/hide Filter Search Table Dataset with Multiple Search and Map on View or Single Search feature
 * Clean-up: ORB-1934 / ORB-1625
 */
const isMultipleSearchTableDataset =
  import.meta.env.VITE_FEATURE_FLAG_IS_MUTIPLE_SEARCH_TABLE_DATASET_ENABLED ===
  "true";

/**
 * Enable New Setup Weight Options
 * Clean-up: ORB-1623
 */
const isNewSetupWeightOptionsEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_NEW_WEIGHT_OPTIONS === "true";

const isRowDatasetManagementEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ROW_DATASET_MANAGEMENT_ENABLED ===
  "true";

/**
 * Show/hide Section Global Filter on Analysis Popup
 * Clean-up: ORB-1909
 */
const isGlobalFilterEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_GLOBAL_FILTER_ENABLED === "true";

/**
 * Show/hide Admin Tree Hierarchy feature in Input Area
 * Clean-up: ORB-1910
 */
const isAdminTreeEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ADMIN_TREE_ENABLED === "true";

/**
 * Analysis History Page
 * Clean-up: ORB-2010
 */
const isAnalysisHistoryEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_ANALYSIS_HISTORY_ENABLED === "true";

/**
 * Analysis AI Summary feature
 * Clean-up: ORB-2164
 */
const isAISummaryEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_AI_SUMMARY_ENABLED === "true";

const isLinestringEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_LINESTRING_ENABLED === "true";

const isTabularViewAnalysisResultEnabled =
  import.meta.env.VITE_FEATURE_FLAG_IS_TABULAR_VIEW_ANALYSIS_RESULT_ENABLED ===
  "true";

const appFeatures = {
  isGroupManagementEnabled,
  isSearchLocationEnabled,
  isChangePasswordEnabled,
  isGroupListOnAddNewUserEnabled,
  isTemplateEnabled,
  isDrawPolygonEnabled,
  isUseNewDatasetExplorerModal,
  isAnalysisJobListEnabled,
  isStorageLimitEnabled,
  isRenameDatasetEnabled,
  isEditUserEnabled,
  isPOIInfoEnabled,
  isLoginWithSsoEnabled,
  isBaseMapStyleSelectorEnabled,
  isNewUIDatasetConfigEnabled,
  isRankingLabelEnabled,
  isRefactorAddDatasetEnabled,
  isMultipleSearchTableDataset,
  isNewSetupWeightOptionsEnabled,
  isRowDatasetManagementEnabled,
  isGlobalFilterEnabled,
  isAdminTreeEnabled,
  isAnalysisHistoryEnabled,
  isAISummaryEnabled,
  isLinestringEnabled,
  isTabularViewAnalysisResultEnabled
};

export default appFeatures;
